import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const ContentSection = lazy(() => import("./ContentSection"));
const WhatWeDoSection = lazy(() => import("./WhatWeDoSection"));
const WhyChooseSection = lazy(() => import("./WhyChooseSection"));
const WhoGotBenefitFromus =  lazy(() => import('./WhoGotBenefitFromus'));

const Manufacture = () => {
  return (
    <>
      <Helmet>
        <title>
          Advanced Manufacturing Solutions | Smart & Efficient Production
        </title>
        <meta
          name="description"
          content="Empower your business with LENTERA’s technology-led manufacturing solutions. From design and prototyping to assembly, quality testing and global delivery, we provide reliable, high-quality and smart production for scalable growth. "
        />

        <meta
          name="keywords"
          content="LENTERA manufacturing services, global manufacturing standards, end-to-end manufacturing process, automated production."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <ContentSection />
        <WhatWeDoSection />
        <WhyChooseSection />
        <WhoGotBenefitFromus />
      </Suspense>
    </>
  );
};

export default Manufacture;
